import { render, staticRenderFns } from "./GestioneAttivitaProgettiEditPage.vue?vue&type=template&id=2c6e1e6a"
import script from "./GestioneAttivitaProgettiEditPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaProgettiEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports